import React from 'react';
import PropTypes from 'prop-types';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionFixed = ({ value }) => {
  return (
    <s.JobDatasheetQuestionFixed>
      {value ? value.value : ''}
    </s.JobDatasheetQuestionFixed>
  );
};

QuestionFixed.propTypes = {
  value: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  }),
};

QuestionFixed.defaultProps = {};
